import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'redux-first-history';

import { Container } from 'ui/gridSystem';
import Modal, { stopEvent } from 'ui/components/Modals/Modal';

import { ModalGlobalContainer } from 'ui/components/Modals/Modal.style';

import { MODAL_CLOSE } from 'redux/actions';
import ProDisplay from 'ui/typography/proDisplay';

import Img from 'ui/assets/img/group.png';
import { PremiumPurchaseConfigSuccessInterface } from 'interface/configuration';
import routes from 'routes';
import { SIGNUP_RESET_CART } from 'redux/actions/signup';
import { ModalWrapper } from '../InviteFriendModal/style';
import {
  Title,
  Subtitle,
  ContentWrapper,
  Icon,
  Image,
  IconCheck,
  Head,
  Bottom
} from './style';

const modalId = 'PremiumPurchaseModal';

const PremiumPurchaseModal = ({
  pushUrl,
  onClose,
  cb,
  premium_purchase: { title, description, list = [], end } = {},
  resetCart
}) => {
  const CloseAndChangeLocation = () => {
    onClose();
    resetCart();
    if(cb) cb();
    pushUrl(routes.allSubsriptions.path);
  };

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer onMouseDown={stopEvent} onClick={stopEvent}>
            <ContentWrapper>
              <Icon className="icon-close-x" onClick={CloseAndChangeLocation} />
              <Image src={Img} />
              <Title>
                <ProDisplay type="modalTitle">{title}</ProDisplay>
              </Title>
              <Subtitle>
                <ProDisplay
                  configuration={{ lineHeight: 1.5, letterSpacing: '0.25px' }}
                >
                  {description ? <Head>{description}</Head> : null}
                  {(list || []).map(item => (
                    <div>
                      <IconCheck className="icon-check" />
                      {item}
                    </div>
                  ))}
                  {end ? <Bottom>{end}</Bottom> : null}
                </ProDisplay>
              </Subtitle>
            </ContentWrapper>
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

PremiumPurchaseModal.propTypes = {
  // HOC (connect, state)
  premium_purchase: PremiumPurchaseConfigSuccessInterface,

  // HOC (connect, dispatch)
  onClose: PropTypes.func.isRequired,
  cb: PropTypes.func,
  pushUrl: PropTypes.func.isRequired,
  resetCart: PropTypes.func.isRequired
};

PremiumPurchaseModal.id = modalId;

export default connect(
  state => {
    const { premium_purchase } = state.configuration;
    return {
      premium_purchase,
      cb: state.modal.payload?.cb
    };
  },
  dispatch => ({
    onClose: () => dispatch({ type: MODAL_CLOSE }),
    resetCart: () => dispatch({ type: SIGNUP_RESET_CART }),
    pushUrl: url => dispatch(push(url))
  })
)(PremiumPurchaseModal);
